import { render, staticRenderFns } from "./ComponentLargeExposureVolume.vue?vue&type=template&id=66d3f64c&scoped=true"
import script from "./ComponentLargeExposureVolume.vue?vue&type=script&lang=js"
export * from "./ComponentLargeExposureVolume.vue?vue&type=script&lang=js"
import style0 from "./ComponentLargeExposureVolume.vue?vue&type=style&index=0&id=66d3f64c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3f64c",
  null
  
)

export default component.exports